import {
  GET_SETTINGS,
  GET_SETTINGS_ERROR,
  GET_SETTINGS_SUCCESS,
  HIDE_SETTINGS_MODAL,
  SAVE_SETTINGS,
  SAVE_SETTINGS_ERROR,
  SAVE_SETTINGS_SUCCESS,
  SHOW_SETTINGS_MODAL,
  SETTINGS_MODAL_ACTIVE_TAB,
} from "../../constants/action-types";

export const personalInformationInitialState = {
  firstName: "",
  lastName: "",
  email: "",
  phoneNumber: "",
  dateOfBirth: "",
};

export const modalInitialState = {
  isOpen: false,
  onSuccess: null,
  claimWarning: "",
};

export const settingsInitialState = {
  personalInformation: personalInformationInitialState,
  isSettingsGetting: false,
  isSettingsSaving: false,
  isSettingsLoaded: false,
  modal: modalInitialState,
};

export const reducer = (state, { type, payload }) => {
  switch (type) {
    case GET_SETTINGS: {
      return {
        ...state,
        isSettingsGetting: true,
      };
    }

    case GET_SETTINGS_SUCCESS: {
      return {
        ...state,
        isSettingsGetting: false,
        isSettingsLoaded: true,
        ...payload,
      };
    }

    case GET_SETTINGS_ERROR: {
      return {
        ...settingsInitialState,
        modal: state.modal,
      };
    }

    case SAVE_SETTINGS: {
      return {
        ...state,
        isSettingsSaving: true,
      };
    }

    case SAVE_SETTINGS_SUCCESS: {
      return {
        ...state,
        isSettingsSaving: false,
        isSettingsLoaded: true,
        ...payload,
      };
    }

    case SAVE_SETTINGS_ERROR: {
      return {
        ...state,
        isSettingsSaving: false,
      };
    }

    case SHOW_SETTINGS_MODAL: {
      const { onSuccess, claimWarning } = payload;

      return {
        ...state,
        modal: {
          ...state.modal,
          isOpen: true,
          onSuccess,
          claimWarning,
          activeTabIndex: 0,
        },
      };
    }

    case HIDE_SETTINGS_MODAL: {
      return {
        ...state,
        modal: {
          ...modalInitialState,
          activeTabIndex: state.modal.activeTabIndex,
        },
      };
    }

    case SETTINGS_MODAL_ACTIVE_TAB: {
      return {
        ...state,
        modal: {
          ...state.modal,
          activeTabIndex: payload,
        },
      };
    }

    default:
      return state;
  }
};
